import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import {observer} from 'mobx-react';
import { motion } from 'framer-motion';

import {times, max, random} from 'lodash';


const RewardBanner = styled(motion.div)`
	position: absolute;
	top: 15vw;
	margin: 0 !important;
	padding: 0;
	height: 100vh;
	z-index: 2000;
	width: 100vw;
`

const Inner = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`

const Rays = styled(motion.img)`
	width: 100vw;
	top: ${store.aspectIs('Tablet') ? 30 : 5}vw;
	position: absolute;
`

const Star = styled(motion.img)`
	width: 10vw;
	position: absolute;
	z-index: 2500;
`

const RewardPanel = styled(motion.div)`
	width: 90vw;
	height: 50vw;
	left: 5vw;
	position: absolute;
	background-size: 100% auto;
	& .xp {
		position: absolute;
		top: 26vw;
		left: 16vw;
		font-size: 10vw;
		color: white;
		text-align: center;
		width: 23vw;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& > span {
			font-size: 6vw;
		}
	}
	& .trophy {
		position: absolute;
		top: 24vw;
		right: 19vw;
		& > img {
			width: 20vw;
		}
	}
	& .levelstar {
		position: absolute;
		top: 25vw;
		left: 20vw;
		font-size: 6.5vw;
		color: white;
		text-align: center;
		width: 17vw;
		height: 17vw;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& img {
			position: absolute;
			top: 0;
			left: 0;
			width: 17vw;
		}
		& .number {
			position: absolute;
			top: 5.9vw;
			width: 100%;
			text-align: center;
			left: 0.5vw;
		}
	}
	& .hearts {
		position: absolute;
		top: 25vw;
		left: 53vw;
		font-size: 6.5vw;
		color: white;
		text-align: center;
		width: 17vw;
		height: 17vw;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& img {
			position: absolute;
			top: 0;
			left: 0;
			width: 17vw;
		}
		& .number {
			position: absolute;
			top: 5.9vw;
			width: 100%;
			text-align: center;
			left: 0.5vw;
			z-index: 10;
		}
	}
`


@observer
export class TopBarAchReward extends Component {
	sfxPlayed = false;
	render(){
		var delayBeforeFirstStar = 1;
		var delayIncrement = 0;

		return (
			<React.Fragment key="achievement-fragment">
				<RewardBanner key="achievement">
					<Inner>
						<Rays alt="" src="/assets/rays.png"
							initial={{rotate: '0deg', scale: 0, y: store.aspectIs('Tablet') ? '5vw' : '25vw'}}
							exit={{
								rotate: '0deg', scale: 0, transition: {duration: 0.1, delay: 0}
							}}
							animate={{rotate:'360deg', scale: 1}}
							transition={{
								delay: 0.4,
								rotate: {type: "tween", ease:"linear", duration: 3, loop: Infinity},
								scale: {duration: 0.5}
							}}
						/>
						<RewardPanel
							style={{
								backgroundImage: `url("/assets/languages/${store.settings.language}/rewardBoxWithBanner.png")`
							}}
							// {window.manager.playAudio("HeartstoHud_single")}
							initial={{y: '-80vw'}}
							exit={{
								y: '-80vw',
								transition: {type: 'tween', duration: 0.5}
							}}
							animate={{y: store.aspectIs('Tablet') ? '25vw' : '50vw'}}
							transition={{
								y: {type: "spring", stiffness: 300, damping: 20, mass: 1.5}
							}}
						>
							<Inner>
								<div className="xp">
									{store.showAchRewardBanner[1]}<br/><span>XP</span>
								</div>
								<div className="trophy">
									<img alt={store.showAchRewardBanner[0] + ' trophy'} src={`/assets/achievements/reward_trophy_${store.showAchRewardBanner[0]}.png`}/>
								</div>
							</Inner>
						</RewardPanel>
					</Inner>
				</RewardBanner>
				{times(store.showAchRewardBanner[1] / 10, (n) => {
					var d = max([(0.15 - (n * 0.01)),0.03]);
					delayIncrement += d;
					if(!this.sfxPlayed) {
						window.manager.playAudio("RewardsPopupStars");
						this.sfxPlayed = true;
					}
					return (
						<Star
							key={`star-${n}`}
							initial={{x: `${random(24,75)}vw`, y: `${store.aspectIs('Tablet') ? random(60,70) : random(85,95)}vw`, scale: 0}}
							animate={{x: '18vw', y: '-1vw', scale: [0,1,1,0]}}
							onAnimationComplete={n === 0 ? (
								this.props.firstStarAnimated.bind(this, n + 2 >= store.showAchRewardBanner[1] / 10)
							) : (n + 2 >= store.showAchRewardBanner[1] / 10 ? (
								this.props.lastStarAnimated
							) : null)}
							transition={{
								default: {delay: delayBeforeFirstStar + delayIncrement, duration: 0.8, ease: 'easeInOut'}
							}}
							src="/assets/hud/hud_icon_star.png"
						/>
					);
				})}
			</React.Fragment>
		)
	}
}
